import { Label } from '@cian/ui-kit';

import { type FC } from 'react';

export const NoFeeLabelContainer: FC = () => {
  return (
    <Label background="surface-main-default" color="accent-main-primary" data-testid="publisher-labels.no-fee">
      Без комиссии
    </Label>
  );
};
